import { useNavigateTo } from '@/routes/hooks/use-navigate-to';
import { useAtom } from 'jotai';
import { contentItemInEditModeState } from '../feed.state';
import type { ContentItem } from '@/api/v4/content-items.api';

export const useToggleContentItemSidebar = () => {
  const navigateTo = useNavigateTo();

  const [, setContentItemInUpdate] = useAtom(contentItemInEditModeState);

  const navigateToFeedTab = () => {
    navigateTo.settings(undefined, { tab: 'feed' });
  };

  const navigateToContentItemSidebar = (contentItem?: ContentItem) => {
    setContentItemInUpdate(contentItem ?? null);

    navigateTo.settings(undefined, {
      tab: 'feed',
      contentItemId: contentItem ? contentItem.id : '',
    });
  };

  return {
    navigateToFeedTab,
    navigateToContentItemSidebar,
  };
};
